<script lang="ts">
    import background from 'src/components/main/home/components/home-hero/home-hero-background.jpg'
    import image from 'src/components/main/home/components/home-hero/image.png'
    import learnMore from 'src/components/main/#assets/learn-more.svg'
    import {Link} from 'svelte-routing'
</script>

<section class="home-hero" style="--Background:url({background});">
    <div class="home-hero-content">
        <div class="container">
            <div class="row mobile-reverse">
                <div class="col-md-7">
                    <div class="h-100 d-flex justify-content-center align-items-center">
                        <img src="{image}" class="image" alt="">
                    </div>
                </div>
                <div class="col-md-5 h-100">
                    <div class="corner-frame">
                        <div class="title">We Create New Worlds</div>
                        <div class="description">Our team of experienced professionals creates unique game worlds and characters, working out their stories, skills, and visuals in detail. We value our community very much and listen to our players opinions on development and innovation.</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<style>
    .home-hero {
        background: var(--Background) no-repeat center;
        min-height: 859px;
        position: relative;
        padding: 170px 0 0;
        background-size: cover;
    }

    .title {
        font-family: 'Anton', sans-serif;
        font-size: 50px;
        font-weight: 400;
        color: white;
        margin: 90px 0 30px;
        line-height: 70px;
        text-transform: uppercase;
        max-width: 720px;
        letter-spacing: 0.02em;
    }

    .description {
        font-size: 16px;
        line-height: 24px;
        color: #A0AEC0;
        margin: 0 0 50px;
    }

    .corner-frame {
        position: relative;
        padding-top: 1px;
        min-height: 470px;
    }

    .corner-frame:before {
        display: block;
        content: '';
        position: absolute;
        border: 2px solid white;
        border-left-color: transparent;
        border-bottom-color: transparent;
        width: 30px;
        height: 30px;
        top: 0;
        right: 0;
        z-index: 2;
    }

    .corner-frame:after {
        display: block;
        content: '';
        position: absolute;
        border: 2px solid white;
        border-left-color: transparent;
        border-top-color: transparent;
        width: 30px;
        height: 30px;
        bottom: 0;
        right: 0;
        z-index: 2;
    }

    .image {
        max-width: 100%;
    }

    @media(max-width: 1400px) {
        .image {
            padding-right: 60px;
        }
    }

    @media(max-width: 1199px) {
        .image {
            padding-right: 40px;
        }
    }

    @media(max-width: 991px) {
        .home-hero {
            padding: 70px 0 50px;
            min-height: initial;
        }
    }

    @media(max-width: 767px) {
        .mobile-reverse {
            flex-direction: column-reverse;
        }

        .title {
            font-size: 30px;
            margin: 50px 0 20px;
            line-height: 30px;
        }

        .description {
            font-size: 13px;
            line-height: 19px;
            margin: 0 0 30px;
        }

        .corner-frame {
            min-height: initial;
            padding-bottom: 60px;
        }

        .image {
            padding-right: 0;
            margin-left: -60px;
            max-width: calc(100% + 60px);
        }
    }
</style>
